<div class="app">
  <router-outlet></router-outlet>
</div>
<overlay></overlay>